import { Grid, TextField, Button } from "@mui/material";

export default function CabSearch() {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField label="Pickup Location" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField label="Drop Location" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            type="datetime-local"
            label="Pickup Time"
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>
      </Grid>

      <Button fullWidth sx={{ mt: 3 }} variant="contained">
        Search Cab
      </Button>
    </>
  );
}
